<template>
    <div style="height: 350px">
        <div>
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="学期">
                            <el-select v-model="$parentInfo.dialog_classHourCart.filter.semester_id"
                                       placeholder="请选择学期"
                                       clearable
                                       style="width:200px"
                                       @change="handleSearchClassHour">
                                <el-option
                                        v-for="item in $parentInfo.dialog_classHourCart.semesters"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="年级">
                            <el-select v-model="$parentInfo.dialog_classHourCart.filter.grade_id"
                                       placeholder="请选择年级"
                                       clearable
                                       style="width:200px"
                                       @change="handleSearchClassHour">
                                <el-option
                                        v-for="item in $parentInfo.dialog_classHourCart.grades"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="名称">
                            <el-select v-model="$parentInfo.dialog_classHourCart.filter.classHour_id"
                                       placeholder="请选择"
                                       clearable
                                       style="width:200px"
                                       @change="handleChooseClassHour">
                                <el-option
                                        v-for="item in $parentInfo.dialog_classHourCart.classHours"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="单价">
                            <el-input v-model="$parentInfo.dialog_classHourCart.filter.unit_price"
                                      placeholder="请输入单价"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课次数">
                            <el-input v-model="$parentInfo.dialog_classHourCart.filter.period"
                                      placeholder="请输入课次数"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                总价：{{$parentInfo.dialog_classHourCart.filter.unit_price*$parentInfo.dialog_classHourCart.filter.period|currency('￥',2)}}
            </el-form>
        </div>
        <div class="text-right">
            <el-button type="primary" @click="handleSettleClassHour()">加入购物车
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ClassHourCart",
        data(){
            return{
                filter:{
                    semester_id:'',
                    grade_id:'',
                    unit_price:'',
                    classHour_id:'',
                    amount:0,
                    sum_price:111,
                },
                classHours:{},
                semesters:[],
                grades:[],
                subjects:[],
                class_types:[],
                times:[
                    {
                        id:1,
                        name:1
                    },
                    {
                        id:2,
                        name:1.5
                    }
                ],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleClassHourInit();
        },
        destroyed(){
            this.$parentInfo.dialog_classHourCart.filter.semester_id='';
            this.$parentInfo.dialog_classHourCart.filter.grade_id='';
            this.$parentInfo.dialog_classHourCart.filter.classHour_id='';
            this.$parentInfo.dialog_classHourCart.filter.unit_price='';
            this.$parentInfo.dialog_classHourCart.filter.period=0;
        },
        methods: {
            handleClassHourInit(){
                this.$wApi.send(this.$parentInfo.path, 'classHour_cart_init', {})
            },
            handleSearchClassHour(){
                this.$parentInfo.dialog_classHourCart.filter.classHour_id='';
                this.$parentInfo.dialog_classHourCart.filter.unit_price='';
                this.$parentInfo.dialog_classHourCart.filter.period=0;
                this.$wApi.send(this.$parentInfo.path, 'search_classHour', {'filter':this.$parentInfo.dialog_classHourCart.filter})
            },
            handleChooseClassHour(){
                if(this.$parentInfo.dialog_classHourCart.filter.classHour_id){
                    this.$parentInfo.dialog_classHourCart.filter.unit_price=
                        this.$parentInfo.dialog_classHourCart.classHours[this.$parentInfo.dialog_classHourCart.filter.classHour_id].price
                }
            },
            handleSettleClassHour(){
                this.$wApi.send(this.$parentInfo.path, 'add_classHour_to_cart',
                    {
                        'student_id':this.$parentInfo.student_id,
                        'classHour_id':this.$parentInfo.dialog_classHourCart.filter.classHour_id,
                        'unit_price':this.$parentInfo.dialog_classHourCart.filter.unit_price,
                        'period':this.$parentInfo.dialog_classHourCart.filter.period
                    }
                )
            }
        }
    }
</script>

<style scoped>

</style>